module.exports = __webpack_public_path__ + "img/background_3.ca5d4733.png";